import { Box, Button, Typography, useTheme } from "@mui/material";
import { ReactNode, useContext } from "react";
import { TierContext } from "../../context/TierContext";

interface UpgradeTierCardProps {
  icon?: ReactNode;
  title?: string;
  description?: string;
  tier?: ""|"Chat-Limit-Standard" | "Chat-Limit-Premium" | "Chat-Limit-Ultimate" | "Sitemap";
  buttonText?: string;
  onUpgrade?: (tier: string) => void;   // custom upgrade action
}

const UpgradeTierCard: React.FC<UpgradeTierCardProps> = ({
  icon,
  title="Upgrade Tier",
  description="Upgrade your tier to access more features",
  tier="",
  buttonText = "Upgrade Subscription ",
  onUpgrade,
}) => {
  const theme = useTheme();
  const { checkPermission } = useContext(TierContext);

  const handleUpgrade = () => {
    if (onUpgrade) {
      onUpgrade(tier);
    } else {
      switch (tier) {
          case "":
            checkPermission("justOpen")
            break;
          case "Chat-Limit-Standard":
            checkPermission("limit:chatLimitStandard");
            break;
          case "Chat-Limit-Premium":
            checkPermission("limit:chatLimitPremium");
            break;
          case "Chat-Limit-Ultimate":
            checkPermission("limit:chatLimitUltimate");
            break;
          case "Sitemap":
            checkPermission("train:sitemaps");
            break;
          default:
            break;
      }
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        p: 2,
        borderRadius: 4,
        bgcolor: theme.palette.background["container-brand-2"],
        gap: 2,
      }}
    >
      {/* Left: Icon + Text */}
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "start", gap: 1 }}>

        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 1
            }}
        >
            {icon}
            <Typography variant="subtitle1" fontWeight={600}>
                {title}
            </Typography>
        </Box>
            <Typography variant="body2" color="text.secondary">
                {description}
            </Typography>
      </Box>

      {/* Right: Upgrade button */}
      <Button
        variant="contained"
        size="medium"
        sx={{
          borderRadius: 2,
          px: 2,
          textTransform: "none",
          bgcolor: `${theme.palette.secondary.main} !important`,
          border: `1px solid ${theme.palette.primary._states.outlinedBorder}`,
          width: { xs: "100%", md: "auto" },
          color: `${theme.palette.secondary.contrastText} !important`,
        }}
        onClick={handleUpgrade}
      >
        {buttonText}
      </Button>
    </Box>
  );
};

export default UpgradeTierCard;
